import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { authAPI } from "../services/AuthAPI";
import { fetchUser } from "../redux/actions/userAction"
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import Button from "./../components/CustomButtons/Button";
import GridContainer from "./../components/Grid/GridContainer.js";
import GridItem from "./../components/Grid/GridItem.js";
import Card from "./../components/Card/Card.js";
import CardBody from "./../components/Card/CardBody.js";
import CardHeader from "./../components/Card/CardHeader.js";
import CardFooter from "./../components/Card/CardFooter.js";
import styles from "../assets/style/login";
import Swal from "sweetalert2";
import LogoImage from "../assets/images/login-bg.png"
import './login.css'
import { imageURL } from "../utils/config";

const Login = () => {
    const Token = localStorage.getItem("Token")
    const useStyles = makeStyles(styles);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user: { isLogin, isLoading, force } } = useSelector(state => state)
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState(false)
    const [prefix, setPrefix] = useState("")
    const [prefixData, setPrefixData] = useState([])
    const [loginfalse, setLoginfalse] = useState(0)

    const icon = [
        { name: 'Com 7', icon: `${imageURL}/icons/icon1.png` },
        { name: 'Double7', icon: `${imageURL}/icons/icon2.png` },
        { name: 'See Know how', icon: `${imageURL}/icons/icon3.png` },
        { name: 'Intervision', icon: `${imageURL}/icons/icon4.png` },
        { name: 'Tec software', icon: `${imageURL}/icons/icon5.png` },
        { name: 'Novus integration', icon: `${imageURL}/icons/icon6.png` },
        { name: 'Thunder finfin', icon: `${imageURL}/icons/icon7.png` },
        { name: 'Adept', icon: `${imageURL}/icons/icon8.png` },
        { name: 'Bakery treasury', icon: `${imageURL}/icons/icon9.png` },
    ]
    const icon1 = [
        { name: 'Success march', icon1: `${imageURL}/icons/icon10.png` },
        { name: 'Club success', icon1: `${imageURL}/icons/icon11.png` },
    ]

    useEffect(() => {
        if (!isLogin && !Token) {
            authAPI.getPrefix()
                .then((res) => {
                    if (res.status == 200) {
                        if (Array.isArray(res.message)) {
                            setPrefixData(res.message)
                        }
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            confirmButtonColor: "#f27474",
                            html: `<span class="colorWhite">${res.message}</span>`,
                            width: '28rem',
                            timer: 3000
                        });
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        width: '28rem',
                        timer: 3000
                    });
                })
        }
    }, [ isLogin, force])

    useEffect(() => {
        if (!Token) {
            dispatch({ type: "CancelLoading" })
        }
    }, [])

    useEffect(() => {
        if (isLogin) {
            navigate('/')
        }
        return () => {
            setUsername("")
            setPassword("")
        }
    }, [isLogin])

    const LoginFunction = (e) => {
        e.preventDefault()
        if (username != "" && password != "" && prefix != "" && loginfalse < 5) {
            setLoading(true)
            let userZ = username
            if (prefix && prefix != "") {
                userZ = `${prefix}${userZ}`
            }
            authAPI.Login({ username: userZ, password })
                .then((response) => {
                    setLoading(false)
                    if (response.status == 200) {
                        localStorage.setItem("Token", response.message)
                        dispatch(fetchUser())
                    }
                    else {
                        setLoginfalse((old) => old + 1)
                        Swal.fire({
                            icon: 'error',
                            confirmButtonColor: "#f27474",
                            html: `<span class="colorWhite">${response.message}</span>`,
                            width: '28rem',
                            timer: 3000
                        });
                    }
                })
                .catch((error) => {
                    setLoading(false)
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${error.message}</span>`,
                        width: '28rem',
                        timer: 3000
                    });
                })
        }
    }

    const classes = useStyles();

    return (
        !isLogin && !isLoading && <div onSubmit={LoginFunction}>
            <div
                className={`${classes.pageHeader} pageHeader`}
                style={{
                    display: "grid",
                    gridTemplateColumns: "60% 40%",
                    gridTemplateRows: "100%",
                    padding: "0%",
                    margin: "0%",
                    width: '100vw',
                    height: '100vh',
                }}
            >
                <div className={`${classes.colleft} col-left`}>
                    <img className="wave" src={LogoImage} alt="" />
                    <h5 style={{ color: '#212529', fontSize: '18px', opacity: '75%' }}>Human Resources (HR)</h5>
                    <h3 style={{ color: '#212529', fontSize: '25px', fontWeight: 600 }}>HR Com7 Documentary</h3>
                </div>
                <div className={`${classes.container} col-right`}>
                    <GridContainer justifyContent="center" className={`${classes.GridContainer} col-GridContainer`}>
                        <GridItem >
                            <Card className={`${classes.Card} enter-card`} style={{ borderRadius: '4px', marginTop: '0', marginBottom: '16px', }}>
                                <form className={classes.form}>
                                    <CardHeader color="primary" className={`${classes.cardHeader} enter-cardHeader`}>
                                        <h3 style={{ color: '#212529', fontSize: '30px' }}>เข้าสู่ระบบ</h3>
                                    </CardHeader>
                                    <p className={classes.divider} style={{ color: '#212529', marginTop: '8px', textAlign: 'start', marginBottom: '0px', marginLeft: '16px', fontSize: '24px', fontWeight: 'bold', }}>
                                        <span style={{ color: '#6ab23a' }}>HR</span> Com<span style={{ color: '#6ab23a' }}>7</span> </p>
                                    <p className={classes.divider} style={{ color: '#212529', marginTop: '8px', textAlign: 'start', marginBottom: '0px', marginLeft: '16px', fontSize: '18px', fontWeight: 'bold', marginTop: '-8px' }}>Documentary</p>
                                    <CardBody className={`${classes.CardBody} enter-CardBody`}>
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <Autocomplete
                                                style={{ width: '37%', marginRight: '3%' }}
                                                options={prefixData}
                                                onChange={(event, newValue) => {
                                                    setPrefix(newValue?.prefix)
                                                }}
                                                renderOption={(props, option) => {
                                                    return (
                                                        <li {...props} key={option._id}>
                                                            {option.org_name}
                                                        </li>
                                                    );
                                                }}
                                                getOptionLabel={(option) => option.org_name || ""}
                                                isOptionEqualToValue={(option) => option.prefix == prefix}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="หน่วยงาน" variant="standard" />
                                                )} />
                                            <TextField style={{ width: '60%' }} value={username} onChange={(e) => setUsername(e.target.value)} label="รหัสพนักงาน" variant="standard" className={classes.UnderLine} />
                                        </div>
                                        <TextField style={{ width: '100%', margin: '16px 0px' }} value={password} type="password" onChange={(e) => setPassword(e.target.value)} label="รหัสผ่าน" variant="standard" className={classes.UnderLine} />
                                    </CardBody>
                                    <CardFooter className={`${classes.cardFooter} button-cardFooter`} >
                                        <span onClick={() => navigate("/forget-password")} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#6ab23a' }}>ลืมรหัสผ่าน</span>
                                        {!loading ?
                                            <Button className={classes.cardButton} simple type="submit" color={`${username == "" || password == "" || prefix == "" || loginfalse >= 5 ? "danger" : "primary"}`} style={{
                                                width: '85px',
                                                height: '32px',
                                                fontWeight: 600,
                                                borderRadius: '24px',
                                                color: 'white',
                                                backgroundColor: username == "" || password == "" || prefix == "" || loginfalse >= 5 ? "lightgray" : '#6ab23a'
                                            }} size="lg"
                                                disabled={username == "" || password == "" || prefix == "" || loginfalse >= 5 ? true : false}
                                                onClick={LoginFunction}>
                                                เข้าสู่ระบบ
                                            </Button> :
                                            <Button className={`${classes.cardButton} cardButton-click`} simple type="submit" color={"primary"} style={{
                                                width: '85px',
                                                height: '32px',
                                                fontWeight: 600,
                                                borderRadius: '24px',
                                                color: 'white',
                                                backgroundColor: "lightgray",
                                            }} size="lg"
                                                disabled={true}
                                            >
                                                <CircularProgress size={16} style={{ color: '#6ab23a' }} />
                                            </Button>}
                                    </CardFooter>
                                    <div className={`${classes.icon} col-icon`}>
                                        {icon.map((res, i) => (
                                            <img key={i} className="icon1" src={res.icon} alt={res.name} />
                                        ))}

                                        {icon1.map((res, i) => (
                                            <img key={i} className="icon2" src={res.icon1} alt={res.name} />
                                        ))}
                                    </div>
                                </form>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        </div>
    )
}
export default Login